import { Link } from 'react-router'
import logo from './images/logo.svg'
import image1 from './images/1.jpg'
import image2 from './images/2.jpg'
import image3 from './images/3.jpg'
import image4 from './images/4.jpg'
import image5 from './images/5.jpg'
import image6 from './images/6.jpg'
import image7 from './images/7.jpg'
import image8 from './images/8.jpg'
import image9 from './images/9.jpg'

const steps = [
  {
    step: '01',
    label: '下準備',
    img: image1,
    desc: '枝が届いたら、なるべく早めに箱から出しましょう。保水ゼリーがついていれば水で洗い流します。次に花器に入れたとき水に浸かる部分の葉をあらかじめ取り除きます。葉が水に入っていると雑菌が繁殖し、枝の持ちに影響があります。そして、よく切れる花ばさみで茎の先を斜めに2〜3cmカット。切り口が斜めになることで水に触れる面積が増え、吸い上げやすくなります。',
    subImgs: [
      { src: image2, caption: '水に浸かる部分の葉を取り除く' },
      { src: image3, caption: '十字に切れ込みを入れる' },
    ],
    tips: [
      '太い枝の場合は、さらに縦に十字に切れ込みを入れるか、ハンマーで軽く叩くと水をよく吸い上げます。切れ味の悪いハサミだと切り口がつぶれて水が吸えなくなるので、なるべくよく切れるものを使いましょう。',
    ],
  },
  {
    step: '02',
    label: '水揚げ',
    img: image4,
    desc: '深めの容器に水をたっぷり入れ、枝を浸して2〜3時間ほど置きます。水は多いほど水圧で吸い上げやすくなるので、深めにするのがポイント。しっかりと水揚げをすることで長旅でお疲れ気味の植物が元気を取り戻します。',
    subImgs: [
      { src: image5, caption: '水は深めにたっぷりと' },
      { src: image6, caption: '紙で包んだ状態で水揚げするのもおすすめ' },
    ],
    tips: ['置く場所は涼しくて暗いところが理想。霧吹きをしてから紙で枝全体をくるんでから深水に浸けるとより効果的。'],
  },
  {
    step: '03',
    label: '飾る',
    img: image7,
    desc: '水揚げが終わったら、お気に入りの花器に入れて完成！枝の長さは花器の高さの2〜3倍が目安。直射日光やエアコンの直風が当たる場所は避けましょう。',
    subImgs: [
      { src: image8, caption: '葉に霧吹きで水を与える' },
      { src: image9, caption: 'お気に入りの場所に飾って楽しんで' },
    ],
    tips: ['葉に霧吹きをすると乾燥しにくく、長持ちします。', '水は2〜3日に一度を目安に交換するのがおすすめ。その際、茎の切り口も少し切り戻してあげましょう。'],
  },
]

export const SubscriptionBranchHowto: React.FC = () => {
  return (
    <div className="min-h-screen bg-bg font-sans">
      <header className="bg-white border-b border-gray/40">
        <div className="max-w-2xl mx-auto px-5 h-14 flex items-center">
          <Link to="/subscription/branch">
            <img src={logo} alt="FLOWER" className="h-7" />
          </Link>
        </div>
      </header>

      <main className="max-w-2xl mx-auto px-5 py-10 flex flex-col gap-8">
        <div>
          <p className="text-[11px] text-dark-gray tracking-widest mb-2">はじめてさん向け</p>
          <h1 className="text-[22px] font-medium text-black leading-relaxed">
            枝ものが届いたら？
            <br />
            まずやってほしい3つのこと
          </h1>
        </div>

        <div className="flex flex-col gap-20">
          {steps.map(({ step, label, desc, tips, img, subImgs }) => (
            <div key={step} className="flex flex-col gap-3">
              <div className="flex flex-col">
                <p className="text-[11px] text-dark-gray tracking-widest uppercase">Step {step}</p>
                <p className="text-[22px] font-medium text-black leading-relaxed mt-1">{label}</p>
              </div>
              <div className="w-full aspect-4/3 rounded-2xl overflow-hidden mt-1">
                <img src={img} alt={label} className="w-full h-full object-cover" />
              </div>
              <div className="flex flex-col mt-1">
                <p className="text-[14px] text-main leading-relaxed">{desc}</p>
                <div className="grid grid-cols-2 gap-2 mt-6">
                  {subImgs.map((si, i) => (
                    <div key={i} className="flex flex-col gap-1.5">
                      <div className="w-full aspect-4/3 rounded-xl overflow-hidden">
                        <img src={si.src} alt={si.caption} className="w-full h-full object-cover" />
                      </div>
                      <p className="text-[11px] text-dark-gray leading-snug">{si.caption}</p>
                    </div>
                  ))}
                </div>
                <div className="border-l-2 border-accent/40 pl-3 mt-5 flex flex-col gap-1.5">
                  <div className="flex items-center gap-1 text-accent/60">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 256 256">
                      <path d="M176,232a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h80A8,8,0,0,1,176,232Zm40-128a87.55,87.55,0,0,1-33.64,69.21A16.24,16.24,0,0,0,176,186v6a16,16,0,0,1-16,16H96a16,16,0,0,1-16-16v-6a16,16,0,0,0-6.23-12.66A87.59,87.59,0,0,1,40,104.49C39.74,56.83,78.26,17.14,125.88,16A88,88,0,0,1,216,104Zm-16,0a72,72,0,0,0-73.74-72c-39,.92-70.47,33.39-70.26,72.39a71.65,71.65,0,0,0,27.64,56.3A32,32,0,0,1,96,186v6h64v-6a32.15,32.15,0,0,1,12.47-25.35A71.65,71.65,0,0,0,200,104Zm-16.11-9.34a57.6,57.6,0,0,0-46.56-46.55,8,8,0,0,0-2.66,15.78c16.57,2.79,30.63,16.85,33.44,33.45A8,8,0,0,0,176,104a9,9,0,0,0,1.35-.11A8,8,0,0,0,183.89,94.66Z"></path>
                    </svg>
                    <p className="text-[10px] tracking-widest font-medium">POINT</p>
                  </div>
                  {tips.map((tip, i) => (
                    <p key={i} className="text-[13px] text-main leading-relaxed">
                      {tip}
                    </p>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  )
}
